import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import AuthPopup from "../Registration/AuthPopup";
import { useNavigate, useLocation, matchPath, NavLink } from "react-router-dom";
import axios from 'axios';

const HeaderComp = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupStep, setPopupStep] = useState('login');
  const [user, setUser] = useState(null);
  const [merchant, setMerchant] = useState(null);
  const [executive, setExecutive] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [executiveImg, setExecutiveImg] = useState(null)
  const [data,setData]=useState(false)

  if (!user || !merchant || !executive) {
    setInterval(() => {
      const merchant = localStorage.getItem('merchantLogin')
      const user = localStorage.getItem('userLogin')
      const executive = localStorage.getItem('excutiveLogin')
      if (merchant) {
        setMerchant(JSON.parse(merchant))
      }
      if (user) {
        setUser(JSON.parse(user))
      }
      if (executive) {
        setExecutive(JSON.parse(executive))
        if(data ===false && executiveImg === null){
          axios.get(`https://api.bakpoket.com/api/BDExecutive/get-profile-photo-binary/${JSON.parse(executive).id}`)
            .then(res => {
              setExecutiveImg(res.data.fileData)
              setData(true)
            })
            .catch(err => console.log(err))
          }
      }
    }, 2000)
  }

  useEffect(()=>{
    setData(true)
    // console.log(data)
  },[executiveImg,data])




  const closePopup = () => {
    setShowPopup(false);
  };

  const renderUserSection = () => {
    if (merchant) {
      return (
        <UserDropdownWrapper>
          <UserProfile>
            {merchant.picture ? (
              <img
                src={merchant.picture}
                alt="Merchant"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/user-icon.png";
                }}
              />
            ) : (
              <img src="/images/user-icon.png" alt="Merchant" />
            )}
            <span style={{ color: '#ef4766' }}>
              {(merchant?.name?.substring(0, 4) || merchant?.merchantName?.substring(0, 4) || merchant?.userName?.substring(0, 4) || "User") + "..."}
            </span>
          </UserProfile>
          <DropdownMenu className="dropdown">
            <p onClick={() => navigate("/merchant/dashboard")}>View Profile</p>
            <p
              onClick={() => {
                localStorage.removeItem("merchantLogin");
                localStorage.removeItem("googleLogin");
                localStorage.removeItem("merchantDashboardLogin");
                navigate("/");
                window.location.reload();
              }}
            >
              Sign Out
            </p>
          </DropdownMenu>
        </UserDropdownWrapper>
      );
    }

    if (user) {
      return (
        <UserDropdownWrapper>
          <UserProfile style={{}}>
            {user.picture ? (
              <img
                src={user.picture}
                alt="User"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/user-icon.png";
                }}
              />
            ) : (
              <img src="/images/user-icon.png" alt="User" />
            )}
            <span style={{ color: '#ef4766' }}>
              {(user?.name?.substring(0, 4) || user?.username?.substring(0, 4) || "User") + "..."}
            </span>
          </UserProfile>
          <DropdownMenu className="dropdown">
            <p onClick={() => navigate("/user/dashboard")}>View Profile</p>
            <p
              onClick={() => {
                localStorage.removeItem("userLogin");
                localStorage.removeItem("googleLogin");
                localStorage.removeItem("userDashboardLogin");
                navigate("/");
                window.location.reload();
              }}
            >
              Sign Out
            </p>
          </DropdownMenu>
        </UserDropdownWrapper>
      );
    }
// data:image/png;base64,
    if (executive) {
      return (
        <UserDropdownWrapper>
          <UserProfile>
            {executiveImg ?<img src={`data:image/png;base64,${executiveImg}`} alt="User" />:<img src="/images/user-icon.png" alt="User" />}
            
            <span style={{ color: '#ef4766' }}>
              {(executive?.username?.substring(0, 4) || executive?.userName?.substring(0, 4) || "User") + "..."}
            </span>
          </UserProfile>
          <DropdownMenu className="dropdown">
            <p onClick={() => navigate("/excutive/dashboard")} >View Profile</p>
            <p
              onClick={() => {
                localStorage.removeItem("userLogin");
                localStorage.removeItem("googleLogin");
                localStorage.removeItem("userDashboardLogin");
                localStorage.removeItem("excutiveLogin");
                navigate("/");
                window.location.reload();
              }}
            >
              Sign Out
            </p>
          </DropdownMenu>
        </UserDropdownWrapper>
      );
    }

    return (
      <UserLogin>

        <div className="dropdown">
          <p type="button" className="p1 dropdown-toggle" data-bs-toggle="dropdown">
            Sign In
          </p>
          <ul className="dropdown-menu">
            <li><NavLink to="/MerchantSignin"
              className="dropdown-item"
              style={{ textDecoration: "none" }}>Merchant</NavLink></li>
            <li><NavLink to="/UserSignin"
              className="dropdown-item"
              style={{ textDecoration: "none" }}>User</NavLink></li>
            <li><NavLink to="/executiveSignin"
              className="dropdown-item"
              style={{ textDecoration: "none" }}>Executive</NavLink></li>
          </ul>
        </div>

        <div className="dropdown">
          <p type="button" className="p2 dropdown-toggle" data-bs-toggle="dropdown">
            Sign Up
          </p>
          <ul className="dropdown-menu">
            <li>
              <NavLink
                to="/MerchantSignup"
                className="dropdown-item"
                style={{ textDecoration: "none" }}
              >
                Merchant
              </NavLink>
            </li>

            <li><NavLink className="dropdown-item" to="/userSignup" style={{ textDecoration: "none" }}>User</NavLink></li>
            <li><NavLink className="dropdown-item" to="/executiveSignup" style={{ textDecoration: "none" }}>Executive</NavLink></li>
          </ul>
        </div>

        {/* <p onClick={openLoginPopup} className="p1" >Sign In</p> */}
        {/* <p onClick={opensignuppopup} className="p2" >Sign Up</p> */}
      </UserLogin>
    );
  };

  return (
    <>
      <BackgroundWrapper>
        <Container>
          <LeftText>Free Coupons & Deals</LeftText>

          <RightSection>
            <SocialIcons>
              <a href="https://www.facebook.com/share/1EgAN769QW/" target="_blank" rel="noreferrer">
                <img src="/images/fb.svg" alt="Facebook" className='img1' />
              </a>
              <a href="https://www.instagram.com/bakpoket_?igsh=MXAwdWM2Y2tiZTMwMQ==" target="_blank" rel="noreferrer">
                <img src="/images/insta.svg" alt="Instagram" className='img1' />
              </a>
              <a href="https://x.com/bakpoketcoupons?t=PRJYpyLLuhefZGMt7jlsOg&s=08" target="_blank" rel="noreferrer">
                <img src="/images/x.svg" alt="Twitter" className='img1' />
              </a>
              <a href="http://www.linkedin.com/in/bakpoket-coupons-332255373" target="_blank" rel="noreferrer">
                <img src="/images/linkedin.svg" alt="LinkedIn" className='img1' />
              </a>
            </SocialIcons>

            <Separator>|</Separator>
            {renderUserSection()}
          </RightSection>
        </Container>
      </BackgroundWrapper>

      {showPopup && (
        <PopupOverlay>
          <PopupContent>
            <AuthPopup step={popupStep} setStep={setPopupStep} onClose={closePopup} />
            <CloseButton onClick={closePopup}>×</CloseButton>
          </PopupContent>
        </PopupOverlay>
      )}
    </>
  );
};

export default HeaderComp;


const zoomInOut = keyframes`
  0% { transform: scale(1); color: #2a4157; }
  50% { transform: scale(1.14); color: #ef4766; }
  100% { transform: scale(1); color: #2a4157; }
`;

const BackgroundWrapper = styled.section`
  // background-color: #ef4766;
  // top: 0;
  // z-index: 999;
  border:2px solid #ef4766;
  background-color: #fff;
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 10px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  // border:1px solid #ef4766;

  @media (max-width: 992px) {
    padding: 10px 20px;
  }

  @media (max-width: 576px) {
    padding: 8px 8px;
  }
`;

const LeftText = styled.p`
  color: #fff;
  margin: 0;
  font-size: 18px;
  animation: ${zoomInOut} 5s ease-in-out infinite;

  @media (max-width: 992px) {
    font-size: 16px;
  }

  @media (max-width: 576px) {
    font-size: 12px;
    margin-left: 3px;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 992px) {
    gap: 10px;
  }

  @media (max-width: 576px) {
    gap: 1px;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;

  a{
     align-items: center;
  }

  .img1{
    width: 31px;
    height: 31px;
    transition: transform 0.2s ease;
    @media (max-width: 768px) {
      width: 28px;
      height: 28px;
    }

    @media (max-width: 576px) {
      width: 23px;
      height: 23px;
    }
  }

  img {
    width: 25px;
    height: 25px;
    transition: transform 0.2s ease;

  
    @media (max-width: 768px) {
      width: 20px;
      height: 20px;
    }

    @media (max-width: 576px) {
      width: 14px;
      height: 14px;
    }
  }

  @media (max-width: 576px) {
    gap: 0px;
  }
`;

const Separator = styled.div`
  color: #ef4766;
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 576px) {
    font-size: 12px;
  }
`;

const UserLogin = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  @media(max-width:576px){
    gap:4px;
  }

  .p1{
    margin-left:3px;
  }

  .p1, .p2 {
    color: #fff;
    font-weight: bold;
    border: 2px solid #ef4766;
    padding: 4px 10px;
    font-size: 14px;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 0px;
    background-color: #ef4766;

    // &:hover {
    //   background-color: #2a4157;
    // }

    @media (max-width: 768px) {
      font-size: 12px;
      padding: 3px 8px;
    }

    @media (max-width: 576px) {
      font-size: 10px;
      padding: 2px 2px;
    }
  }
`;

const PopupOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const PopupContent = styled.div`
  position: relative;
`;

// const CloseButton = styled.button`
//   position: absolute;
// top: 20px;
// right: 16px;
// font-size: 20px;
//   color: rgba(0, 0, 0, 0.6);
//   border: none;
//   cursor: pointer;
//   border-radius: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index:1000;
//   height:25px;
// `;

const CloseButton = styled.span`
  position: absolute;
  top: 20px;
  right: 16px;
  font-size: 17px;
  font-weight: bold;
  color: #000;
  background: #F6F6F6;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  cursor: pointer;
  text-align:center;
`;

const UserProfile = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-weight: bold;

  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #fff;
  }

  @media (max-width: 576px) {
    img {
      width: 24px;
      height: 24px;
    }
    span {
      font-size: 12px;
    }
  }
`;

const UserDropdownWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .dropdown {
    display: block;
  }
`;

// const DropdownMenu = styled.div`
//   display: none;
//   position: absolute;
//   right: 0;
//   top: 100%;
//   background-color: white;
//   color: black;
//   min-width: 140px;
//   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
//   border-radius: 4px;
//   z-index: 100;

//   p {
//     padding: 10px 12px;
//     margin: 0;
//     font-size: 14px;
//     cursor: pointer;
//     border-bottom: 1px solid #eee;

//     &:hover {
//       background-color: #f3f3f3;
//     }

//     &:last-child {
//       border-bottom: none;
//     }
//   }
// `;


const DropdownMenu = styled.div`
  display: none;
  position: absolute;
  right: 0;
  top: 100%;
  background-color: white;
  color: black;
  min-width: 140px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 100;

  p {
    padding: 10px 12px;
    margin: 0;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 1px solid #eee;

    &:hover {
      background-color: #f3f3f3;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  @media (max-width: 768px) {
    min-width: 100px;

    p {
      padding: 8px 10px;
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    min-width: 90px;

    p {
      padding: 6px 8px;
      font-size: 11px;
    }
  }
`;
